import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AuthHelperService } from 'app/auth/helpers/auth-helper.service';
import * as AuthActions from 'app/store/actions/auth.action';
import * as AuthSelectors from 'app/store/selectors/auth.selectors';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-auth-sso',
  templateUrl: './auth-sso.component.html',
  styleUrls: ['./auth-sso.component.scss']
})

export class AuthSsoComponent implements OnInit, OnDestroy {
  public ssoForm: FormGroup;
  public submitted = false;
  public loading = false;
  public error = '';
  private _unsubscribeAll: Subject<void>;

  constructor(
    private _formBuilder: FormBuilder,
    private store: Store,
    private authHelper: AuthHelperService
  ) {
    this._unsubscribeAll = new Subject<void>();
    this.authHelper.setLayoutConfig(true, false, true);
  }

  ngOnInit(): void {
    this.ssoForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });

    // subscribe to loading flag from store
    this.store.select(AuthSelectors.authFormLoader)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((loading) => this.loading = !!loading);

    // subscribe to error from store
    this.store.select(AuthSelectors.authError)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((err) => this.error = err || '');
  }

  onSubmit(): void {
    this.submitted = true;
    // clear any previous inline error in store
    this.store.dispatch(AuthActions.clearAuthError());

    if (this.ssoForm.invalid) return;

    const email = this.ssoForm.value.email;
    // dispatch SSO login action (effect will handle service call and redirect)
    this.store.dispatch(AuthActions.ssoLogin({ email }));
  }

  get form() {
    return this.ssoForm.controls;
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
